import React, { useRef, useState } from "react";
import RightDrawer from "../../components/ui/RightDrawer";
import Listing from "../../components/ui/Listing";
import { destroy, get } from "../../server";
import {
	ADMIN_SPONSOR_DELETE,
	ADMIN_SPONSOR_LISTING,
	ADMIN_SPONSOR_LISTING_SEARCH,
} from "../../data/constants/apiRoutes";
import queryNames from "../../data/constants/queryNames";
import { useNavigate } from "react-router-dom";
import {
	Stack,
	IconButton,
	Typography,
	Button,
	FormControl,
	OutlinedInput,
	InputAdornment,
	Tooltip,
	Avatar,
} from "@mui/material";
import { ReactComponent as Search } from "../../assets/svg/Search.svg";
import styles from "../../assets/styles/company/companyListing.styles";
import { ReactComponent as Edit } from "../../assets/svg/Edit.svg";
import { ReactComponent as Delete } from "../../assets/svg/Delete.svg";
import { useMutation, useQueryClient } from "react-query";
import { useSnackbar } from "notistack";
import BoxModal from "../../components/Modals/BoxModal";
import { Clear } from "@mui/icons-material";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import LoadingButton from "../../components/Buttons/LoadingButton";

function SponsorsListing() {
	const [modal, setModal] = useState(false);
	const [sponsorId, setSponsorId] = useState();
	const sponsorRef = useRef();

	const [search, setSearch] = useState("");
	const [finalSearch, setFinalSearch] = useState("");
	const [isSearch, setIsSearch] = useState(false);

	const navigate = useNavigate();

	const client = useQueryClient();

	const { enqueueSnackbar } = useSnackbar();

	const columns = [
		{
			field: "company_name",
			headerName: "Company Name",
			sortable: false,
			flex: 1,
			renderCell: (params) => {
				return (
					<>
						<Stack
							direction="row"
							alignItems="center"
							sx={{ cursor: "pointer" }}
						>
							<Avatar
								src={params.row.image}
								sx={{
									bgcolor: "gray",
									mr: 1.5,
									width: 35,
									height: 35,
								}}
							/>
							{params.row.company_name}
						</Stack>
					</>
				);
			},
		},
		{
			field: "sponser_name",
			headerName: "Sponsor Name",
			sortable: false,
			flex: 1,
		},
		{
			field: "email",
			headerName: "Email",
			sortable: false,
			flex: 1,
		},
		{
			field: "address",
			headerName: "Address",
			sortable: false,
			width: 150,
			flex: 1,
		},
		{
			field: "action",
			headerName: "Action",
			sortable: false,
			renderCell: (params) => {
				return (
					<Stack direction="row" spacing={2}>
						<Tooltip title="Edit" arrow placement="top">
							<IconButton
								onClick={() => navigate(`/sponsors/edit/${params.row.id}`)}
							>
								<Edit />
							</IconButton>
						</Tooltip>
						<Tooltip title="Delete" arrow placement="top">
							<IconButton
								onClick={() => {
									setSponsorId(params.row.id);
									setModal("delete");
								}}
							>
								<Delete />
							</IconButton>
						</Tooltip>
					</Stack>
				);
			},
		},
	];

	const fetchSponsors = async (pageNo, limit, searchParam, isSearchParam) => {
		let url;

		if (isSearchParam === false) {
			url = new URL(ADMIN_SPONSOR_LISTING);
		} else if (isSearchParam && searchParam.length) {
			url = new URL(ADMIN_SPONSOR_LISTING_SEARCH);
			url.searchParams.append("search", searchParam);
		}

		url.searchParams.append("page", pageNo + 1);
		url.searchParams.append("limit", limit);

		return await get(url.toString());
	};

	const handleInvalidate = () => {
		client.invalidateQueries(queryNames.SPONSOR);
	};

	const handleClose = () => {
		setModal(false);
		setSponsorId(null);
		handleInvalidate();
	};

	const handleAction = async () => {
		const { status, message } = await destroy(
			`${ADMIN_SPONSOR_DELETE}/${sponsorId}`
		);

		if (status) {
			enqueueSnackbar(message, { variant: "success" });
			handleClose();
		} else {
			enqueueSnackbar(message, { variant: "error" });
		}
	};

	const mutation = useMutation(handleAction, {
		onSuccess: () => {
			client.invalidateQueries([queryNames]);
		},
	});

	const handleConfirm = (e) => {
		e.preventDefault();
		mutation.mutate();
	};

	const handleSearchClick = () => {
		if (search.length) {
			setIsSearch(true);
			setFinalSearch(search);
		}
	};

	const handleCancleSearch = () => {
		setIsSearch(false);
		setSearch("");
	};

	return (
		<>
			<Stack direction="row" sx={styles.wrapper} gap={1.25}>
				<Typography component="h1">Exhibitors / Booths</Typography>
				{isSearch && (
					<IconButton onClick={handleCancleSearch}>
						<Clear />
					</IconButton>
				)}
				<FormControl variant="outlined" sx={styles.searchInput} fullWidth>
					<OutlinedInput
						size="small"
						type="text"
						value={search}
						onChange={(e) => setSearch(e.target.value)}
						onKeyDown={(e) => {
							if (e.key === "Enter") {
								handleSearchClick();
							}
						}}
						endAdornment={
							<InputAdornment position="end">
								<Tooltip title="Search">
									<IconButton onClick={handleSearchClick}>
										<Search />
									</IconButton>
								</Tooltip>
							</InputAdornment>
						}
						placeholder="Search Sponsors.."
					/>
				</FormControl>
				<Button
					sx={styles.button}
					variant="contained"
					onClick={() => navigate("/sponsors/add")}
				>
					Add Sponsor
				</Button>
			</Stack>

			<Listing
				columns={columns}
				queryName={queryNames.SPONSOR}
				fetchRecords={fetchSponsors}
				search={finalSearch}
				isSearch={isSearch}
			/>
			{/* <RightDrawer
				modal={modal === "detail"}
				setModal={setModal}
				id={sponsorRef.current?.id}
			/> */}

			<BoxModal
				// header="Are you sure?"
				title="Do you really want to Delete this Sponsor?"
				open={modal}
				handleClose={handleClose}
				handleConfirm={handleConfirm}
				confirmButton="Delete"
				confirmButtonColor="#2B2A69"
				cancelButtonColor="#E8EEF5"
				isLoading={mutation.isLoading}
				data={sponsorId}
			/>
		</>
	);
}

export default SponsorsListing;
